export enum FieldMode {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
}

export enum FieldSize {
  Small = 'small',
  Big = 'big',
}
